import { render, staticRenderFns } from "./PostSuccessModal.vue?vue&type=template&id=956dd8be&scoped=true"
import script from "./PostSuccessModal.vue?vue&type=script&lang=js"
export * from "./PostSuccessModal.vue?vue&type=script&lang=js"
import style0 from "./PostSuccessModal.vue?vue&type=style&index=0&id=956dd8be&lang=less&scoped=true"
import style1 from "./PostSuccessModal.vue?vue&type=style&index=1&id=956dd8be&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "956dd8be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/saas_fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('956dd8be')) {
      api.createRecord('956dd8be', component.options)
    } else {
      api.reload('956dd8be', component.options)
    }
    module.hot.accept("./PostSuccessModal.vue?vue&type=template&id=956dd8be&scoped=true", function () {
      api.rerender('956dd8be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/globalModals/PostSuccessModal.vue"
export default component.exports